import { IGuestValidationSession } from '../../model';
import { CONSTANT } from './constant';

const DEFAULT_GUEST_VALIDATION_TTL_MINUTES = 120;

function buildGuestValidationKey(
  tenantId: number,
  locationId: number,
  tableId: number
): string {
  return `${CONSTANT.GUEST_VALIDATION_SESSION}_${tenantId}_${locationId}_${tableId}`;
}

export function saveGuestValidationSession(
  tenantId: number,
  locationId: number,
  tableId: number,
  contact?: string,
  mobileDigits?: string,
  ttlMinutes: number = DEFAULT_GUEST_VALIDATION_TTL_MINUTES
): void {
  const session: IGuestValidationSession = {
    tenantId,
    locationId,
    tableId,
    contact,
    mobileDigits,
    verifiedAt: Date.now(),
    ttlMinutes,
  };
  localStorage.setItem(
    buildGuestValidationKey(tenantId, locationId, tableId),
    JSON.stringify(session)
  );
}

export function getValidGuestValidationSession(
  tenantId: number,
  locationId: number,
  tableId: number
): IGuestValidationSession | null {
  const key = buildGuestValidationKey(tenantId, locationId, tableId);
  const raw = localStorage.getItem(key);
  if (!raw) {
    return null;
  }

  let session: IGuestValidationSession;
  try {
    session = JSON.parse(raw);
  } catch {
    localStorage.removeItem(key);
    return null;
  }

  const expired =
    Date.now() - session.verifiedAt > session.ttlMinutes * 60000;
  if (expired) {
    localStorage.removeItem(key);
    return null;
  }

  return session;
}

export function clearGuestValidationSession(
  tenantId: number,
  locationId: number,
  tableId: number
): void {
  localStorage.removeItem(buildGuestValidationKey(tenantId, locationId, tableId));
}
